<template>
    <div class="card">
        <div class="card">
            <TabMenu :model="items"/>
            <router-view/>
        </div>
    </div>
</template>

<script>

export default {
    name: "TestRouter",
    components: {},
    data() {
        return {
            items: [
                {
                    label: 'ציונים',
                    icon: 'pi pi-pencil',
                    to: '/test',
                    admin: false
                },  {
                    label: 'מבחנים',
                    icon: 'pi pi-tags',
                    to: '/test/names',
                    admin: false
                },
                {
                    label: 'טבלה',
                    icon: 'pi pi-table',
                    to: '/test/table',
                    admin: false
                },
            ]
        }
    },
}
</script>

<style scoped>
>>> .p-menuitem-link span {
    margin-left: 7px
}
</style>